(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["supply-lab-home"] && !Shopify.designMode) return;
  try {
    
  const offer = document.querySelector('.bc-offer');
  if (offer instanceof HTMLDialogElement) {
    const closeButton = offer.querySelector('[data-bc-offer-close]');
    const success = offer.querySelector('[data-bc-offer-success]');
    const dismissalKey = 'sply-brush-check-offer-dismissed-session';
    const dismissedThisSession = sessionStorage.getItem(dismissalKey) === 'true';

    const openOffer = () => {
      if (!offer.open) offer.showModal();
    };

    if (success) {
      openOffer();
    } else if (!dismissedThisSession) {
      window.setTimeout(openOffer, 2200);
    }

    closeButton?.addEventListener('click', () => {
      sessionStorage.setItem(dismissalKey, 'true');
      offer.close();
    });

    offer.addEventListener('click', (event) => {
      if (event.target === offer) {
        sessionStorage.setItem(dismissalKey, 'true');
        offer.close();
      }
    });

    offer.addEventListener('cancel', () => {
      sessionStorage.setItem(dismissalKey, 'true');
    });

    const copyButton = offer.querySelector('[data-bc-copy]');
    copyButton?.addEventListener('click', async () => {
      await navigator.clipboard.writeText(copyButton.dataset.bcCopy || '');
      const label = copyButton.querySelector('small');
      if (label) label.textContent = copyButton.dataset.bcCopySuccess || '';
    });
  }

  } catch(e) { console.error(e); }
})();
})();
